import closeIcon from '@/components/Icons/Modals/IconClose.vue';

export default{
	mounted(){
		setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			modalActive: false,
			newEditionSuccess: false,

			///////////////
			//// CHANGE PASSWORD
			dNewEdition:{
				name: "",
				description: "",
			}  
		}
	},

	
	components:{
		closeIcon,
	},

	methods:{
		closeModal(){

			this.$parent.modal_newEdition = false;
			this.newEditionSuccess = false;
			setTimeout(() => {
				location.reload();
			}, 500);
		},
		newEdition(scope){
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					(async	 () => {
						var rawResponse = await fetch('https://api.salonacme.com/manager/new_edition', {
							method: 'POST',
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								_id: this.$session.get('_id'),
								data: this.dNewEdition
							})
						});
						const content = await rawResponse.json();
						if(content.status){
							this.newEditionSuccess = true;
							this.dNewEdition.name = content.actual_edition.name;
							this.dNewEdition.description = content.actual_edition.description;
							this.$parent.actual_edition = this.dNewEdition.name;
						}
						else{}
							// alert(content.msg);
					})();
				}
			});

		}
	}
}